import { RouteObject } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import { CreateKPIQuestionList } from "./features/kpi-question-list/components/CreateKPIQuestionList";
import { UpdateKPIQuestionList } from "./features/kpi-question-list/components/UpdateKPIQuestionList";
import { AppLayout } from "./shared/sidebar/app-layout";
import { ViewAllKPIQuestionList } from "./features/kpi-question-list/components/ViewAllKPIQuestionList";
import { CreateKPIForm } from "./features/kpi-form/components/CreateKPIForm";
import { ViewAllKPIForm } from "./features/kpi-form/components/ViewAllKPIForm";
import { UpdateKPIForm } from "./features/kpi-form/components/UpdateKPIForm";
import { ViewAllKPIFormArchived } from "./features/kpi-form-archived/components/ViewAllKPIFormArchived";
import { FormStartPage } from "./features/kpi-form-user/components/FormStartPage";
import { FormFillPage } from "./features/kpi-form-user/components/FormFillPage";
import { FormReviewPage } from "./features/kpi-form-user/components/FormReviewPage";
import { ViewAllUserKPIForm } from "./features/kpi-form-user/components/ViewAllUserKPIForm";
/**
 * Centralized route configuration
 *
 * To add a new route:
 * 1. Import your page component
 * 2. Add route object to the array:
 *    - Public route: { path: '/about', element: <About /> }
 *    - Protected route: { path: '/dashboard', element: <ProtectedRoute><Dashboard /></ProtectedRoute> }
 */
export const routes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/create-kpi-question-list",
        element: <CreateKPIQuestionList />,
      },
      {
        path: "/view-all-kpi-question-list",
        element: <ViewAllKPIQuestionList />,
      },
      {
        path: "/update-kpi-question-list/:id",
        element: <UpdateKPIQuestionList />,
      },
      {
        path: "/create-kpi-form",
        element: <CreateKPIForm />,
      },
      {
        path: "/view-all-kpi-form",
        element: <ViewAllKPIForm />,
      },
      {
        path: "/update-kpi-form/:id",
        element: <UpdateKPIForm />,
      },
      {
        path: "/view-all-kpi-form-archived",
        element: <ViewAllKPIFormArchived />,
      },
      {
        path: "/kpi-form-user",
        element: <FormStartPage />,
      },
      {
        path: "/user-kpi-form/:id",
        element: <FormFillPage />,
      },
      {
        path: "/view-all-user-kpi-form",
        element: <ViewAllUserKPIForm />,
      },
      {
        path: "/review-kpi-form/:id",
        element: <FormReviewPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
